import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LeagueNews, LeagueNewsType } from '@mtgame/core';
import { shareFB, shareVK } from '@utils/share';

@Component({
  selector: 'mtg-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsDetailComponent {
  @Input()
  news: LeagueNews;
  @Input()
  backUrl: string[];
  newsTypes = LeagueNewsType;

  get shareUrl(): string {
    return window && window.location.href;
  }
}
